import React from "react";
import { useTranslation } from "react-i18next";

const Loading = ({ text }) => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10">
          <div className="aai-hero-two-content d-flex text-center flex-column align-items-center justify-content-center">
            <h3 className="aai-hero-two-title">
              {/* High-Quality Way to Write your{" "} */}
              <span className="gradient-text typing-animation">
                {`${t(text)}`}
              </span>
            </h3>
            {/* Modern Animated Loader */}
            <div className="loader"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
